<template>
        <section class="base-header-sec base-header-laen  laen">
            <div class="base-header__top-line laen"></div>
            <div class="container-fluid">
                <div class=" container-lg  base-header__container ">
                    <div class="inner ml-lg-5 d-flex justify-content-between align-items-center">
                        <ul class="nav">
                            <li class="nav-item">
                                <router-link class="nav-link" to="/calc/zatezne-kamate">Затезне камате</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" to="/calc/sudske-takse">Судске таксе</router-link>
                            </li>
                            <li class="nav-item">
                                <router-link class="nav-link" to="/calc/pomoc">Помоћ</router-link>
                            </li>
                        </ul>
                        <h1 class="base-header__title">
                            КАЛКУЛАТОРИ
                        </h1>
                    </div>
                </div>
            </div>
        </section>
</template>

<script>
    export default {
        name: "CalculatorBaseHeaderSec"
    }
</script>

<style scoped>

</style>
